__webpack_require__.p = "/update-pdfjs/referrals-hub/";